<template>
  <li ref="parentLi"  
  :style="`--data-width:-${computedWidth}px`"
  :class="[dataItem.classes, dataItem.child_items && dataItem.child_items.length > 1 ? 'has-more' : '']"  >
   <a  
   v-if="!dataItem.child_items"
      :href="dataItem.url"
       @click.prevent="handleRouterClick($event, dataItem)" 
      :data-target="`dropdown-${dataItem.ID}`"
      :class="isOpened ? 'opened' : ''" 
      ref="dropTrigger" class="top-level dropdown-trigger" 
      v-html="dataItem.title">
      </a> 
      
      <a
        v-else
      :href="dataItem.url"
       @click.prevent 
      :data-target="`dropdown-${dataItem.ID}`"
      :class="isOpened ? 'opened' : ''" 
      ref="dropTrigger" class="top-level dropdown-trigger" 
      v-html="dataItem.title">
      </a> 
    <ul 
     role="menu" 
    :class="isOpened ? 'opened' : ''"  @keyup.up.prevent="nextLink($event, 'up')" @keyup.down.prevent="nextLink($event, 'down')" 
    :id="`dropdown-${dataItem.ID}`" class="dropdown-content" ref="dropDown" v-if="childItemsX">
    <div class="ul-hack " style="user-select:none" tabindex="-1">
      <li v-for="item in childItemsX" :key="item.id" class="dp-section" >
      <span v-if="item.child_items" :class="item.classes" v-html="item.title"  tabindex="-1"></span>
      <a :href="item.url"  v-else @click.prevent="handleRouterClick($event, item)" class="regular" :class="item.classes" v-html="item.title" ></a>
        <ul v-if="item.child_items" tabindex="0"  >
          <li tabindex="0" :class="sub.classes" v-for="sub in item.child_items" :key="sub.id" :style="`--data-hover-value:${sub.title}`">
            <router-link   :to="sub.route"  >
              <span  v-html="sub.title"></span>
            </router-link>
          </li>
        </ul>
      </li>
    </div>
    </ul>
  </li>
</template>
<script>
import M from 'materialize-css'
export default {
  name: 'NavDropDown',
  props: {
    dataItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isEllipsed:[],
      computedWidth:0,
      tabbedLinks:[],
      focusedIndex:-1,
      dropDown: {
        instance: null,
        options: {
          coverTrigger: false,
          hover: false,
          constrainWidth: false,
          onOpenEnd: () => {
            this.tabbedLinks = this.$el.querySelectorAll('a:not(.top-level)')
          },
          onCloseEnd: () =>{
            this.tabbedLinks = []
            this.focusedIndex = -1
          }
      //    outDuration: 0,
          // container: ".dropdown-container",
        },
      },
    }
  },
  mounted() {
    this.$_initDropdown()
    this.computedWidth = this.$refs.parentLi.offsetWidth
  },
  computed: {
    isOpened:{
      get () {
        return this.dropDown.instance !== null
        ? this.dropDown.instance.isOpen
        : false
      }
    },
    mainUrlX() {
      if (this.dataItem.object === 'page') {
        return {
          name: 'PageTemplate',
          params: { page: this.dataItem.slug },
          query: {
            t: 'page',
          },
        }
      } else if (this.dataItem.object === 'category') {
        return {
          name: 'CategoryTemplate',
          params: { slug: this.dataItem.slug },
        }
      } else if (this.data.object === 'custom') {
        return {
          name: 'PageTemplate',
          params: { page: this.dataItem.slug },
          query: {
            t: 'custom',
          },
        }
      }
      return '/'
    },
    childItemsX() {
      if (this.dataItem && this.dataItem.child_items) {
        return this.dataItem.child_items.map(item => {
          if (item.child_items) {
            item.child_items = item.child_items.reduce((result, child) => {
              const route = this.$_constructChildUrl(child)
              result.push({ ...child, route })
              return result
            }, [])
          }

          return item
        })
      }
      return false
    },
  },
  methods: {
    $_isLinkable(routeItem) {
      return routeItem.object === 'custom'
    },
    nextLink(e, direction)  {
    if(!this.dropDown.instance.isOpen) return
    if(direction === 'down') {
       if (this.focusedIndex < 1) {
        this.focusedIndex += 1
        setTimeout(() => {
            this.tabbedLinks[this.focusedIndex].focus()
      }, 100);
       
       }
       else 
       {
        
        this.focusedIndex  === this.tabbedLinks.length - 1
         ?  this.focusedIndex = 0
         :  this.focusedIndex += 1
        setTimeout(() => {
          this.tabbedLinks[this.focusedIndex].focus()
        }, 100);
       }
    } else {
      if(this.focusedIndex === 0) {
        this.focusedIndex = this.tabbedLinks.length - 1
         setTimeout(() => {
          this.tabbedLinks[this.focusedIndex].focus()
        }, 100);
      } else {
        this.focusedIndex -= 1
         setTimeout(() => {
          this.tabbedLinks[this.focusedIndex].focus()
        }, 100);
      }
    }
    
    },
    addTo (a, x) {
      let pw = a.target.parentNode.offsetWidth
      let w = a.target.offsetWidth
      if (w > pw) {
        
        if(this.isEllipsed.length < 1) {
            this.isEllipsed.push(x)
          } else {
            const record = this.isEllipsed.findIndex(y => y === x)
            if(record < 0) this.isEllipsed.push(x)
          }
      }
     
    },
    tipStatus (x){
      const record = this.isEllipsed.findIndex(y => y === x)

      return record > -1
    },
    handleRouterClick(event, routeObj) {
     // console.log(routeObj)
     // eslint-disable-next-line no-constant-condition
    if(routeObj.type === 'taxonomy' )  this.$router.push({...routeObj.route}) 
      if(routeObj.type === 'custom' && !routeObj.url.startsWith('https://members.eccourts.org') && !routeObj.url.startsWith('/')) {
      routeObj.target === '_blank' 
        ? window.open(routeObj.url)
        : window.location.href = routeObj.url
      } else if(routeObj.type === 'custom' && routeObj.url.startsWith('/')) {
        this.$router.push({path:routeObj.url})
      } else if (this.mainUrlX){
        this.$router.push(this.mainUrlX)
      } else return
      
      // if (routeObj.object === 'page') {
      //   this.$store.commit('main/UPDATE_POST_TYPE', 'page')
      // }

      // const path = isParent ? this.$_constructUrl() : this.$_constructChildUrl(routeObj)
      // this.$router.push(path)
    },

    $_constructUrl() {
      if (this.dataItem.object === 'page') {
        return {
          name: 'PageTemplate',
          params: { page: this.dataItem.slug },
        }
      } else if (this.dataItem.object === 'category') {
        return {
          name: 'category',
          params: { slug: this.dataItem.slug },
        }
      } else if (this.data.object === 'custom') {
        return {
          name: 'PageTemplate',
          path:this.dataItem.url
        /*   params: { page: this.dataItem.slug },
          query: {
            t: 'custom',
          }, */
        }
      }

      return '/'
    },
    $_constructChildUrl(childItem) {
      if (childItem.object === 'page') {
        return {
          name: 'PageChildTemplate',
          params: { page: this.dataItem.slug, slug: childItem.slug },
          query: {
            t: 'page',
          },
        }
      } else if (childItem.object === 'category') {
        return {
          name: 'category',
          params: { slug: childItem.slug },
        }
      } 
      else if( childItem.object === 'custom') {
        return {
          path:childItem.url
        }
      }

      return '/'
    },
    $_initDropdown() {
     // console.log(this.$refs.dropTrigger)
      if (!this.dataItem.child_items) return
      this.dropDown.instance = M.Dropdown.init(this.$refs.dropTrigger, this.dropDown.options)
      this.$el.querySelector('a')
    },
  },
}
</script>
<style lang="scss" scoped>
a, span {
  font-weight: 500;
  color: rgba(0,0,0,0.85);
  font-family: 'Source Sans Pro', sans-serif;
}
.top-level {
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: .5px;
  font-weight: 600;
}
li {
   &.has-more {
      position: relative;
     &::before {
          content: 'expand_more';
          font-family: 'Material Icons Outlined';
          position: absolute;
          color: #1d2530;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 14px;
          z-index: -1;
          line-height: 1;
      }
    }
  &.two-columns {
   
    ul.dropdown-content {  
        height: auto !important;
        min-width: 40vw !important;
        max-width: 690px !important;
        left: var(--data-width) !important;
        border-radius: 6px;
        padding: 10px;
        span, div {
          &.ul-hack { 
            display: flex !important;
            flex-wrap: wrap;
          }
        }
      li {
        min-height: 0px !important;
        
          &:hover {
            background: transparent;
          }
          &.dp-section {
            width: 50%;
            padding: 0 4px;
          }
          a {
            line-height: 22px;
            padding: 10px 8px;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
      }
    }
  }
}
.ul-hack { 
  a, span {
    font-family: 'Roboto', sans-serif;
  }
      }
.dropdown-content {
  border-radius: 6px;
  padding: 10px;
  li {
    &.dp-section {
      &:hover {
        background: transparent;
      }
    }
    span {
      &.is-heading {
        border-bottom: 1px solid #e4e4e4;
        margin-bottom: 8px;
        font-size: 17px;
        font-weight: 500;
        padding: 14px 16px;
      }
    }
  }
  .dp-section {
    span {
      color: #000;
    }
  }
  li {
    a {
      color: #000;
    }
  }
}
a {
  &.regular {
    line-height: 22px;
    padding: 10px 8px;
  }
}
</style>

<style lang="scss"></style>
